module.exports = __webpack_public_path__ + "static/img/com_2.dc54b99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/com_2.png
// module id = SspH
// module chunks = 0